/*
 * WorldRecordDetails Messages
 *
 * This contains all the text for the WorldRecordDetails component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.WorldRecordDetails';

export default defineMessages({
  name: {
    id: `${scope}.name`,
    defaultMessage: 'Name',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Save',
  },
  recordType: {
    id: `${scope}.recordType`,
    defaultMessage: 'Type',
  },
  maleValue: {
    id: `${scope}.maleValue`,
    defaultMessage: 'Men value',
  },
  femaleValue: {
    id: `${scope}.femaleValue`,
    defaultMessage: 'Women value',
  },
});
